module.exports = __webpack_public_path__ + "img/icons-list-4.ed0ec976.png";